export default __webpack_public_path__ + "static/media/Chart.90d5abd0.svg";